var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79645 6.38026C7.23815 6.38026 8.40687 5.24602 8.40687 3.84687C8.40687 2.44772 7.23815 1.31348 5.79645 1.31348C4.35476 1.31348 3.18604 2.44772 3.18604 3.84687C3.18604 5.24602 4.35476 6.38026 5.79645 6.38026Z",
    stroke: "#F9FCFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40686 7.39355H8.59063C8.97231 7.39366 9.34082 7.52902 9.62692 7.77421C9.91302 8.0194 10.097 8.35754 10.1444 8.72511L10.3485 10.308C10.3668 10.4506 10.3537 10.5953 10.3101 10.7326C10.2664 10.8699 10.1931 10.9966 10.0951 11.1044C9.99707 11.2121 9.87658 11.2983 9.74159 11.3574C9.60661 11.4165 9.46022 11.447 9.31215 11.447H2.28072C2.13265 11.447 1.98627 11.4165 1.85128 11.3574C1.7163 11.2983 1.5958 11.2121 1.49779 11.1044C1.39978 10.9966 1.3265 10.8699 1.28281 10.7326C1.23912 10.5953 1.22603 10.4506 1.24439 10.308L1.448 8.72511C1.49535 8.35737 1.6795 8.01909 1.96582 7.77388C2.25214 7.52866 2.6209 7.39341 3.00277 7.39355H3.18602",
    stroke: "#F9FCFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserProfile);
export default __webpack_public_path__ + "static/media/userProfile.dae1d75bc56d154197cd00f5d3b17c0c.svg";
export { ForwardRef as ReactComponent };